import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import './attachmentsSection.scss'

const AttachmentsSection = React.memo(({ imagesList }) => {
  const [attachments, setAttachments] = useState({})

  useEffect(() => {
    if (imagesList) {
      setAttachments(imagesList)
    }
  }, [imagesList])

  return (
    <div className="attachments-main">
      <h2>Images</h2>

      <div className="attachments-section">
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            <Grid size={12}></Grid>
            {attachments != null && attachments.length > 0 ? (
              attachments.map((element) => {
                return (
                  <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                    <img src={element.url} alt="" />
                    <div className="caption-container">
                      <label>{element.caption}</label>
                    </div>
                  </Grid>
                )
              })
            ) : (
              <></>
            )}
          </Grid>
        </Container>
      </div>
    </div>
  )
})

export default AttachmentsSection
